'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinToConstraintPropType = exports.autoPlacementPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PlacementConstants = require('../PlacementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var autoPlacementPropType = exports.autoPlacementPropType = _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['horiz', 'vert'])]);

var pinToConstraintPropType = exports.pinToConstraintPropType = _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/utils/propTypes.js
// module id = 179
// module chunks = 177